import React, {useEffect, useLayoutEffect, useMemo, useState} from 'react';
import {
  DeviceEventEmitter,
  Modal,
  NativeScrollEvent,
  NativeSyntheticEvent,
  Platform,
  Pressable,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
  Keyboard,
} from 'react-native';
import {TouchableWithoutFeedback} from 'react-native';
import HomeContent from './tabComponents/HomeContent';
import Animated, {FadeInRight} from 'react-native-reanimated';
import useHomeScreenAnimation from './useHomeScreenAnimation';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import UserEvents from './tabComponents/UserEvents';
import {SCREENS} from '~constants';
import {useNavigation} from '@react-navigation/native';
import {NavigationProps} from '~types/navigation/navigation.type';
import useTabBar from '~containers/Core/navigation/AppScreens/zustand';
import {useTranslation} from 'react-i18next';
import BusinessEvents from './tabComponents/BusinessEvents';
import {useGetUserType} from '~hooks/event/useGetUserType';
import Svg from 'react-native-svg';
import {Path} from 'react-native-svg';
import Slider from '@react-native-community/slider';
import {useHomeStore} from '~providers/home/zustand';
import LikedContened from './tabComponents/LikedContent';
import {DATE_FORMAT, DateToggle} from '~components/DateTimeToggle';
import moment from 'moment';
import {widthPercentageToDP as wp, heightPercentageToDP as hp} from 'react-native-responsive-screen';
import {Switch} from 'react-native-switch';
// Conditionally import OneSignal for native platforms only
import * as oneSignalStub from '~services/web/oneSignalStub';
let OneSignal: any = null;
if (Platform.OS !== 'web') {
  OneSignal = require('react-native-onesignal').default;
} else {
  OneSignal = oneSignalStub.OneSignal;
}
import MapListView from '~components/MapListView';
// import HomeScreenLocationButton from './HomeScreenLocationButton';
import FloatingPlusIcon from '~assets/icons/FloatingPlusIcon';
import {Event} from '~types/api/event';
import EventDetailsBottomSheet from './tabComponents/HomeContent/EventDetailsBottomSheet';
import Config from 'react-native-config';
import {useTheme} from '~contexts/ThemeContext';
import ModernHomeHeader from './ModernHomeHeader';
import FullScreenFilterModal from './FullScreenFilterModal';
import {useQuery} from 'react-query';
import axios from 'axios';
import {BASE_API_URL} from '@env';
import NeighbourhoodRestrictionModal from './NeighbourhoodRestrictionModal';
import {useUserStore} from '~providers/userStore/zustand';
import {useMapsContext} from '~providers/maps/zustand';
import {runOnUIThread} from '~Utils/uiThreadSafety';

interface FilterButtonsProps {
  setIsMapView: (value: boolean) => void;
  isMapView: boolean;
}

const HomeScreenTabs = () => {
  const {t} = useTranslation();
  const {colors} = useTheme();
  const {currentPositionState} = useMapsContext();

  const [globalInputValue, setGlobalInputValue] = useState('');
  const [isMapView, setIsMapView] = useState<boolean>(false);
  const [selectedServiceType, setSelectedServiceType] = useState<'THE_REST_TABLE' | 'CULTURAL_EDIT' | null>('THE_REST_TABLE'); // Default to Culture Edit

  const eventTypes = [
    {
      id: 1,
      title: t('home.all_events'),
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
        isMapView: boolean,
        setIsMapView: (value: boolean) => void,
        selectedServiceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null,
        handleServiceTypeChange: (serviceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null) => void,
        timeframes: Array<{id: number; title: string}>,
        handleQuickFilterSelect: (timeframe: {id: number; title: string}) => void,
      ) => (
        <HomeContent
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          selectedTimeframe={selectedTimeframe}
          globalInputValue={globalInputValue}
          isMapView={isMapView}
          isNeighbourhood={selectedTimeframe.id === 8}
          isPyxiSelect={selectedTimeframe.id === 9}
          isPyxiCore={selectedTimeframe.id === 10}
          setIsMapView={setIsMapView}
          eventServiceType={(() => {
            const serviceType = selectedTimeframe.id === 9 ? selectedServiceType : null;
            console.log('🎯 [PROP PASSING] Passing eventServiceType:', {
              selectedTimeframeId: selectedTimeframe.id,
              isPyxiSelect: selectedTimeframe.id === 9,
              selectedServiceType,
              finalServiceType: serviceType
            });
            return serviceType;
          })()}
          onServiceTypeChange={handleServiceTypeChange}
          selectedServiceType={selectedServiceType}
          timeframes={timeframes}
          onTimeframeSelect={handleQuickFilterSelect}
        />
      ),
    },
    {
      id: 2,
      title: t('events.users'),
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
        isMapView: boolean,
        setIsMapView: (value: boolean) => void,
      ) => (
        <UserEvents
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          selectedTimeframe={selectedTimeframe}
          globalInputValue={globalInputValue}
          isMapView={isMapView}
          setIsMapView={setIsMapView}
        />
      ),
    },
    {
      id: 3,
      title: t('events.suggestions'),
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
        isMapView: boolean,
        setIsMapView: (value: boolean) => void,
      ) => (
        <BusinessEvents
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          selectedTimeframe={selectedTimeframe}
          globalInputValue={globalInputValue}
          isMapView={isMapView}
          setIsMapView={setIsMapView}
        />
      ),
    },
    /* {
      id: 4,
      title: 'My events',
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
      ) => (
        <PersonalEvents
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          selectedTimeframe={selectedTimeframe}
          globalInputValue={globalInputValue}
          timeframe={null}
        />
      ),
    }, */
    {
      id: 5,
      title: t('events.liked'),
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
        isMapView: boolean,
        setIsMapView: (value: boolean) => void,
      ) => (
        <LikedContened
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          selectedTimeframe={selectedTimeframe}
          globalInputValue={globalInputValue}
          isMapView={isMapView}
          setIsMapView={setIsMapView}
        />
      ), // Update this as needed
    },
    {
      id: 6,
      title: t('events.free'),
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
        isMapView: boolean,
        setIsMapView: (value: boolean) => void,
        selectedServiceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null,
        handleServiceTypeChange: (serviceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null) => void,
        timeframes: Array<{id: number; title: string}>,
        handleQuickFilterSelect: (timeframe: {id: number; title: string}) => void,
      ) => (
        <HomeContent
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          isFree={true}
          selectedTimeframe={selectedTimeframe}
          isNeighbourhood={selectedTimeframe.id === 8}
          isPyxiSelect={selectedTimeframe.id === 9}
          isPyxiCore={selectedTimeframe.id === 10}
          globalInputValue={globalInputValue}
          isMapView={isMapView}
          setIsMapView={setIsMapView}
          eventServiceType={selectedTimeframe.id === 9 ? selectedServiceType : null}
          onServiceTypeChange={handleServiceTypeChange}
          selectedServiceType={selectedServiceType}
          timeframes={timeframes}
          onTimeframeSelect={handleQuickFilterSelect}
        />
      ),
    },
    {
      id: 7,
      title: t('events.neighbourhood_gropus'),
      component: (
        scrollHandler: (event: NativeSyntheticEvent<NativeScrollEvent>) => void,
        filterEvents: (data: any, selectedTimeframe: {id: number; title: string}) => any,
        selectedTimeframe: {id: number; title: string},
        globalInputValue: string,
        isMapView: boolean,
        setIsMapView: (value: boolean) => void,
        selectedServiceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null,
        handleServiceTypeChange: (serviceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null) => void,
        timeframes: Array<{id: number; title: string}>,
        handleQuickFilterSelect: (timeframe: {id: number; title: string}) => void,
      ) => (
        <HomeContent
          scrollHandler={scrollHandler}
          filterEvents={filterEvents}
          isNeighbourhood={true}
          selectedTimeframe={selectedTimeframe}
          isPyxiCore={selectedTimeframe.id === 10}
          globalInputValue={globalInputValue}
          isMapView={isMapView}
          setIsMapView={setIsMapView}
          eventServiceType={selectedTimeframe.id === 9 ? selectedServiceType : null}
          onServiceTypeChange={handleServiceTypeChange}
          selectedServiceType={selectedServiceType}
          timeframes={timeframes}
          onTimeframeSelect={handleQuickFilterSelect}
        />
      ),
    },
  ];

  const allTimeframes = [
    /* {
      id: 1,
      title: t('home.upcoming_events'),
      value: 'Upcoming Events',
    },
    {
      id: 2,
      title: t('events.today'),
      value: 'Today',
    },
    {
      id: 3,
      title: t('events.tomorrow'),
      value: 'Tomorrow',
    },
    {
      id: 5,
      title: t('events.thisweekend'),
      value: 'This Weekend',
    },
    {
      id: 7,
      title: t('events.past'),
      value: 'Past',
    }, */
    {
      id: 9,
      title: t('events.pyxi_select'),
      value: 'Pyxi Select',
      showInUK: true,
      showOutsideUK: false,
    },
    {
      id: 8,
      title: t('events.neighbourhood_gropus'),
      value: 'Neighbourhoods',
      showInUK: true,
      showOutsideUK: false,
    },
    {
      id: 10,
      title: t('events.pyxi_core'),
      value: 'PyXi Core',
      showInUK: false,
      showOutsideUK: true,
    },
  ];

  // Initialize with allTimeframes, will be filtered based on country
  const [timeframes, setTimeframes] = useState(allTimeframes);

  const {top} = useSafeAreaInsets();

  const {setIsTabBarDisabled} = useTabBar();
  const user = useUserStore(state => state.user);
  const {data: userType} = useGetUserType(user?.uid!);
  const navigation = useNavigation<NavigationProps>();
  const [selectedEventType, setSelectedEventType] = useState(eventTypes[0]);
  const [selectedTimeframe, setSelectedTimeframe] = useState(timeframes[0]);
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);

  // Track selectedServiceType changes
  useEffect(() => {
    console.log('🎯 [HOME SCREEN TABS] selectedServiceType state changed to:', selectedServiceType);
  }, [selectedServiceType]);

  // Track selectedTimeframe changes to see which tab is active
  useEffect(() => {
    console.log('📋 [HOME SCREEN TABS] Current tab info:', {
      selectedTimeframeId: selectedTimeframe?.id,
      selectedTimeframeTitle: selectedTimeframe?.title,
      isPyxiSelectTab: selectedTimeframe?.id === 9,
      selectedServiceType: selectedServiceType
    });
  }, [selectedTimeframe, selectedServiceType]);

  // Filter timeframes based on country
  useEffect(() => {
    if (currentPositionState?.country) {
      const {country} = currentPositionState;
      const isUK = country === 'United Kingdom';
      const filteredTimeframes = allTimeframes.filter(filter => (isUK ? filter.showInUK : filter.showOutsideUK));

      // If currently selected timeframe is not in filtered list, select first available
      if (filteredTimeframes.length > 0) {
        setTimeframes(filteredTimeframes);

        // Check if current selection is valid in the new filtered list
        const isCurrentSelectionValid = filteredTimeframes.some(frame => frame.id === selectedTimeframe.id);

        if (!isCurrentSelectionValid) {
          setSelectedTimeframe(filteredTimeframes[0]);
        }
      }
    }
  }, [currentPositionState?.country]);

  useEffect(() => {
    const eventListener = DeviceEventEmitter.addListener('homeLocationChange', data => {
      if (data?.country) {
        runOnUIThread(() => {
          const {country} = data;
          const isUK = country === 'United Kingdom';
          const filteredQuickFilters = allTimeframes.filter(filter => (isUK ? filter.showInUK : filter.showOutsideUK));
          setTimeframes(filteredQuickFilters);
        });
      }
    });

    return () => {
      eventListener.remove();
    };
  }, []);

  // Filter modal states
  const [isFullScreenFilterVisible, setIsFullScreenFilterVisible] = useState(false);
  const [isTimeframeModalVisible, setIsTimeframeModalVisible] = useState(false);
  const [isEventTypeModalVisible, setIsEventTypeModalVisible] = useState(false);
  const [isNeighbourhoodRestrictionModalVisible, setIsNeighbourhoodRestrictionModalVisible] = useState(false);
  const {radius, isForKids, setRadius, setIsForKids} = useHomeStore();
  const [tempSelectedTimeframe, setTempSelectedTimeframe] = useState(selectedTimeframe);
  const [tempSelectedEventType, setTempSelectedEventType] = useState(selectedEventType);
  const [isChildrenEventsLocal, setChildrenEventsLocal] = useState(isForKids);
  const [radiusLocal, setRadiusLocal] = useState(radius);
  const {scrollHandler, scrollAnimatedStyle, addEventButtonStyle} = useHomeScreenAnimation();

  // const [dynamicStartDate, setDynamicStartDate] = useState(moment(new Date(), DATE_FORMAT));
  // const [dynamicEndDate, setDynamicEndDate] = useState(moment(new Date(), DATE_FORMAT));

  const [dynamicStartDate, setDynamicStartDate] = useState<moment.Moment | null>(null);
  const [dynamicEndDate, setDynamicEndDate] = useState<moment.Moment | null>(null);
  const {data: groups, refetch: refetchGroup} = useQuery<any[]>('joined-groups', async () => {
    const token = useUserStore.getState().token;
    const config = {
      headers: {Authorization: token, Accept: 'application/json'},
    };
    const response = await axios.get(BASE_API_URL + 'community/joined', config);
    return response.data;
  });
  const isGroupJoined = groups && groups.length > 0;

  useEffect(() => {
    const listner = DeviceEventEmitter.addListener('onGroupJoin', async () => {
      await refetchGroup();
      // Find the neighborhood timeframe from current filtered timeframes
      const neighborhoodTimeframe = timeframes.find(tf => tf.id === 8);
      if (neighborhoodTimeframe) {
        setSelectedTimeframe(neighborhoodTimeframe);
      }
    });

    // Listen for location changes to filter timeframes by country
    const locationListener = DeviceEventEmitter.addListener('homeLocationChange', data => {
      if (data && data.country) {
        runOnUIThread(() => {
          const isUK = data.country === 'United Kingdom';
          const filteredTimeframes = allTimeframes.filter(filter => (isUK ? filter.showInUK : filter.showOutsideUK));

          if (filteredTimeframes.length > 0) {
            setTimeframes(filteredTimeframes);

            // Check if current selection is valid in the new filtered list
            const isCurrentSelectionValid = filteredTimeframes.some(frame => frame.id === selectedTimeframe.id);

            if (!isCurrentSelectionValid) {
              setSelectedTimeframe(filteredTimeframes[0]);
            }
          }
        });
      }
    });

    return () => {
      listner.remove();
      locationListener.remove();
    };
  }, [selectedTimeframe]);

  // Function to check if neighbourhood filter can be applied
  const canApplyNeighbourhoodFilter = (timeframe: any) => {
    const isNeighbourhoodFilter = timeframe.title === t('events.neighbourhood_gropus') || timeframe.id === 8;
    if (isNeighbourhoodFilter && !isGroupJoined) {
      setIsNeighbourhoodRestrictionModalVisible(true);
      return false;
    }
    return true;
  };

  // console.log('dynamicStartDate', dynamicStartDate);
  // console.log('dynamicEndDate', dynamicEndDate);
  // const [radius, setRadius] = useState(50);
  // const [isChildrenEvents, setChildrenEvents] = useState(isForKids);

  useLayoutEffect(() => {
    const focusListener = navigation.addListener('focus', () => {
      console.log('Focus event triggered, selectedEvent:', selectedEvent);
      if (!selectedEvent) {
        console.log('setIsTabBarDisabled false');
        setIsTabBarDisabled(false);
      }
    });

    // Cleanup the listener on unmount or when selectedEvent changes
    return () => {
      focusListener();
    };
  }, [selectedEvent, navigation, setIsTabBarDisabled]);

  useEffect(() => {
    // Update OneSignal external user ID using v4 API (skip on web)
    const currentUser = user;
    if (currentUser?.uid && Platform.OS !== 'web') {
      console.log('OneSignal: Setting external user ID:', currentUser.uid);

      OneSignal.setExternalUserId(currentUser.uid, (results: any) => {
        // The results will contain push and email success statuses
        console.log('Results of setting external user id');
        console.log(results);
        // Push can be expected in almost every situation with a success status, but
        // as a pre-caution its good to verify it exists
        if (results.push && results.push.success) {
          console.log('Results of setting external user id push status:');
          console.log(results.push.success);
        }
        // Verify the email is set or check that the results have an email success status
        if (results.email && results.email.success) {
          console.log('Results of setting external user id email status:');
          console.log(results.email.success);
        }
        // Verify the number is set or check that the results have an sms success status
        if (results.sms && results.sms.success) {
          console.log('Results of setting external user id sms status:');
          console.log(results.sms.success);
        }

        // After setting user ID, ensure push notifications are enabled for logged-in users
        setTimeout(async () => {
          try {
            const deviceState = await OneSignal.getDeviceState();
            console.log('OneSignal device state after user ID set:', deviceState);

            // If push is disabled, enable it for logged-in users
            if (deviceState?.isPushDisabled) {
              console.log('🔧 Re-enabling push notifications for logged-in user');
              OneSignal.disablePush(false);
            }
          } catch (error) {
            console.error('❌ Failed to check/fix OneSignal state:', error);
          }
        }, 1000);
      });
    }

    const eventSelectionListener = DeviceEventEmitter.addListener('eventSelection', data => {
      const item = data.event;
      if (item) {
        navigation.navigate(SCREENS.HOME_EVENT, {
          tag: `${item.event_id}=tag`,
          eventId: item.event_id,
          item: item,
        });
      }
    });

    return () => {
      eventSelectionListener.remove();
    };
  }, []);

  const filterEvents = (data: any[], selectedTimeframe: {id: number; title: string}) => {
    const now = new Date();

    // Set today's start and end
    const todayStart = new Date(now);
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date(now);
    todayEnd.setHours(23, 59, 59, 999);

    // Set tomorrow's start and end
    const tomorrowStart = new Date(todayStart);
    tomorrowStart.setDate(todayStart.getDate() + 1);
    const tomorrowEnd = new Date(tomorrowStart);
    tomorrowEnd.setHours(23, 59, 59, 999);

    var curr = new Date(); // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    const saturday = new Date(new Date(curr.setDate(last)).setHours(0, 0, 0, 0));
    var lastday = new Date(new Date(curr.setDate(last)).setHours(23, 59, 59, 999));
    const sunday = new Date(lastday.setDate(lastday.getDate() + 1));

    if (selectedTimeframe.title === t('events.now')) {
      return data?.filter((event: any) => {
        const startDate = new Date(event.start_date);
        const endDate = new Date(event.end_date);
        return startDate <= now && endDate >= now && startDate.getHours() <= now.getHours();
      });
    } else if (selectedTimeframe.title === t('home.upcoming_events')) {
      return data?.filter((event: any) => {
        const endDate = new Date(event.end_date);
        return endDate > now;
      });
    } else if (selectedTimeframe.title === t('events.today')) {
      return data?.filter((event: any) => {
        const startDate = new Date(event.start_date);
        const endDate = new Date(event.end_date);
        return startDate <= todayEnd && endDate >= todayStart;
      });
    } else if (selectedTimeframe.title === t('events.tomorrow')) {
      return data?.filter((event: any) => {
        const startDate = new Date(event.start_date);
        const endDate = new Date(event.end_date);
        return (
          (startDate >= tomorrowStart && startDate <= tomorrowEnd) ||
          (endDate >= tomorrowStart && endDate <= tomorrowEnd) ||
          (startDate <= tomorrowStart && endDate >= tomorrowEnd)
        );
      });
    } else if (selectedTimeframe.title === t('events.thisweekend')) {
      return data;
      return data?.filter((event: any) => {
        const endDate = new Date(event.end_date);
        return endDate > saturday && endDate < sunday;
      });
    } else if (selectedTimeframe.title === t('events.this_week')) {
      const startOfWeek = new Date(now);
      startOfWeek.setDate(now.getDate() - now.getDay()); // Start of current week (Sunday)
      startOfWeek.setHours(0, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // End of current week (Saturday)
      endOfWeek.setHours(23, 59, 59, 999);

      return data?.filter((event: any) => {
        const startDate = new Date(event.start_date);
        return startDate >= startOfWeek && startDate <= endOfWeek;
      });
    } else if (selectedTimeframe.title === t('events.weekend')) {
      return data;
      const startOfWeek = new Date(now);
      startOfWeek.setDate(now.getDate() - now.getDay()); // Start of current week (Sunday)

      const saturday = new Date(startOfWeek);
      saturday.setDate(startOfWeek.getDate() + 6); // Saturday
      saturday.setHours(0, 0, 0, 0);

      const sunday = new Date(startOfWeek);
      sunday.setDate(startOfWeek.getDate() + 7); // Next Sunday
      sunday.setHours(23, 59, 59, 999);

      return data?.filter((event: any) => {
        const eventStart = new Date(event.start_date);
        const eventEnd = new Date(event.end_date);

        // Check if event overlaps with Saturday to Sunday
        return eventStart <= sunday && eventEnd >= saturday;
      });
    } else if (selectedTimeframe.title === t('events.next_week')) {
      const startOfNextWeek = new Date(now);
      startOfNextWeek.setDate(now.getDate() - now.getDay() + 7); // Start of next week (Sunday)
      startOfNextWeek.setHours(0, 0, 0, 0);

      const endOfNextWeek = new Date(startOfNextWeek);
      endOfNextWeek.setDate(startOfNextWeek.getDate() + 6); // End of next week (Saturday)
      endOfNextWeek.setHours(23, 59, 59, 999);

      return data?.filter((event: any) => {
        const startDate = new Date(event.start_date);
        return startDate >= startOfNextWeek && startDate <= endOfNextWeek;
      });
    } else if (selectedTimeframe.title === t('events.past')) {
      return data?.filter((event: any) => {
        const endDate = new Date(event.end_date);
        const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
        return endDate < now && endDate >= thirtyDaysAgo;
      });
    } else if (
      selectedTimeframe.title === t('events.neighbourhood_gropus') ||
      selectedTimeframe.title === t('events.pyxi_select') ||
      selectedTimeframe.title === t('events.pyxi_core')
    ) {
      // Check if user is joined to any groups for neighbourhood filter
      if (selectedTimeframe.title === t('events.neighbourhood_gropus') && !isGroupJoined) {
        return [];
      }
      return data?.filter((event: any) => {
        const endDate = new Date(event.end_date);
        const threeHoursLater = new Date(now.getTime() - 3 * 60 * 60 * 1000);
        return endDate > threeHoursLater;
      });
    } else if (selectedTimeframe.id === 0) {
      return data?.filter((event: any) => {
        const endDate = new Date(event.end_date);
        return (
          dynamicStartDate && dynamicEndDate && endDate > dynamicStartDate.toDate() && endDate < dynamicEndDate.toDate()
        );
      });
    } else {
      console.log('selectedTimeframe 0', selectedTimeframe);
      return [];
    }
  };

  const selectedEventTypeData = eventTypes.find(item => item.id === selectedEventType.id);
  // const selectedTimeframeData = timeframes.find(item => item.id === selectedTimeframe.id);

  // Filter handlers
  const handleTimeframePress = () => {
    setTempSelectedTimeframe(selectedTimeframe);
    setRadiusLocal(radius);
    setChildrenEventsLocal(isForKids);
    setIsTimeframeModalVisible(true);
  };

  const handleEventTypePress = () => {
    setTempSelectedEventType(selectedEventType);
    setIsEventTypeModalVisible(true);
  };

  const handleFilterPress = () => {
    // Open full-screen filter modal
    setIsFullScreenFilterVisible(true);
  };

  const handleQuickFilterSelect = (timeframe: any) => {
    if (canApplyNeighbourhoodFilter(timeframe)) {
      setSelectedTimeframe(timeframe);
    }
  };

  const handleServiceTypeChange = (serviceType: 'THE_REST_TABLE' | 'CULTURAL_EDIT' | null) => {
    console.log('HomeScreenTabs - handleServiceTypeChange called with:', serviceType);
    console.log('HomeScreenTabs - Previous selectedServiceType:', selectedServiceType);
    setSelectedServiceType(serviceType);
    console.log('HomeScreenTabs - After setSelectedServiceType, new value should be:', serviceType);
  };

  const handleFullScreenFilterApply = (eventType: any, isForKids: boolean, radius: number) => {
    setSelectedEventType(eventType);
    setIsForKids(isForKids);
    setRadius(radius);
  };

  const applyTimeframeChanges = () => {
    if (canApplyNeighbourhoodFilter(tempSelectedTimeframe)) {
      setSelectedTimeframe(tempSelectedTimeframe);
      setRadius(radiusLocal);
      setIsForKids(isChildrenEventsLocal);
    }
    setIsTimeframeModalVisible(false);
  };

  const applyEventTypeChanges = () => {
    setSelectedEventType(tempSelectedEventType);
    setIsEventTypeModalVisible(false);
  };

  const listComponent = useMemo(() => {
    const EventTypeComponent = selectedEventTypeData?.component(
      scrollHandler,
      filterEvents,
      selectedTimeframe,
      globalInputValue,
      isMapView,
      setIsMapView,
      selectedServiceType,
      handleServiceTypeChange,
      timeframes,
      handleQuickFilterSelect,
    );
    // const TimeframeComponent = selectedTimeframeData?.component(scrollHandler);
    // console.log(selectedTimeframe);
    return (
      <>
        {/* {TimeframeComponent} */}
        {EventTypeComponent}
      </>
    );
  }, [scrollHandler, selectedEventType, selectedTimeframe, globalInputValue, isMapView, setIsMapView, selectedServiceType]);

  const header = useMemo(() => {
    return (
      <ModernHomeHeader
        scrollAnimatedStyle={scrollAnimatedStyle}
        globalInputValue={globalInputValue}
        setGlobalInputValue={setGlobalInputValue}
        selectedTimeframe={selectedTimeframe}
        selectedEventType={selectedEventType}
        isMapView={isMapView}
        setIsMapView={setIsMapView}
        onTimeframePress={handleTimeframePress}
        onEventTypePress={handleEventTypePress}
        onFilterPress={handleFilterPress}
        onQuickFilterSelect={handleQuickFilterSelect}
        isForKids={isForKids}
        radius={radius}
        timeframes={timeframes}
        eventTypes={eventTypes}
      />
    );
  }, [
    scrollAnimatedStyle,
    globalInputValue,
    selectedEventType,
    selectedTimeframe,
    isMapView,
    isForKids,
    radius,
    timeframes,
    eventTypes,
    handleTimeframePress,
    handleEventTypePress,
    handleFilterPress,
    handleQuickFilterSelect,
  ]);

  return (
    <TouchableWithoutFeedback
      onPress={() => {
        DeviceEventEmitter.emit('hideSuggestion');
        if (Keyboard.isVisible()) {
        Keyboard.dismiss();
        }
      }}>
      <View style={{flex: 1}}>
        <Animated.View
          entering={FadeInRight.duration(300)}
          style={{
            zIndex: 10000,
            position: 'absolute',
            bottom: hp('15%'),
            right: hp('2.5%'),
            backgroundColor: colors.background,
          }}
        />
        <View style={{flex: 1, backgroundColor: colors.background}}>
          {header}
          <Animated.View style={[{
            flex: 1,
            backgroundColor: colors.background,
            overflow: Platform.OS === 'web' ? 'scroll' : 'hidden',
          }]}>
            {listComponent}
          </Animated.View>
        </View>
        {selectedEvent && <EventDetailsBottomSheet event={selectedEvent} />}

        {/* Full Screen Filter Modal */}
        <FullScreenFilterModal
          visible={isFullScreenFilterVisible}
          onClose={() => setIsFullScreenFilterVisible(false)}
          selectedEventType={selectedEventType}
          eventTypes={eventTypes}
          isForKids={isForKids}
          radius={radius}
          onApply={handleFullScreenFilterApply}
        />

        {/* Timeframe Filter Modal */}
        <Modal visible={isTimeframeModalVisible} transparent={true} animationType="fade">
          <TouchableOpacity
            onPress={() => {
              setIsTimeframeModalVisible(false);
              applyTimeframeChanges();
            }}
            style={{
              flex: 1,
              justifyContent: 'flex-end',
              backgroundColor: colors.overlayBackground,
            }}>
            <TouchableOpacity
              activeOpacity={1}
              onPress={e => {
                e.isPropagationStopped;
              }}
              style={{
                width: '100%',
                backgroundColor: colors.white,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                padding: hp('2.5%'),
                height: hp('71%'),
              }}>
              <Text style={{fontSize: hp('2.5%'), fontWeight: 'bold', marginBottom: hp('1%')}}>
                {t('events.lookingforevents')}
              </Text>
              <View
                style={{
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'flex-start',
                  marginBottom: hp('0.5%'),
                }}>
                {timeframes.map(timeframe => (
                  <TouchableOpacity
                    key={timeframe.id}
                    style={{
                      paddingVertical: hp('1%'),
                      paddingHorizontal: hp('2%'),
                      borderRadius: 20,
                      backgroundColor: tempSelectedTimeframe.id === timeframe.id ? colors.warning : colors.white,
                      borderWidth: 1,
                      borderColor: tempSelectedTimeframe.id === timeframe.id ? colors.warning : colors.black,
                      margin: hp('0.5%'),
                    }}
                    onPress={() => setTempSelectedTimeframe(timeframe)}>
                    <Text
                      style={{
                        color: tempSelectedTimeframe.id === timeframe.id ? colors.white : colors.black,
                        fontSize: hp('1.8%'),
                        fontWeight: '500',
                      }}>
                      {timeframe.title}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>
              <TouchableOpacity
                onPress={applyTimeframeChanges}
                style={{
                  marginTop: hp('1.5%'),
                  backgroundColor: colors.secondary,
                  paddingVertical: hp('1.25%'),
                  paddingHorizontal: hp('5%'),
                  borderRadius: 25,
                  width: '100%',
                  alignItems: 'center',
                  marginBottom: hp('1%'),
                }}>
                <Text style={{color: colors.white, fontSize: hp('2%'), fontWeight: 'bold'}}>{t('events.apply')}</Text>
              </TouchableOpacity>
            </TouchableOpacity>
          </TouchableOpacity>
        </Modal>

        {/* Event Type Filter Modal */}
        <Modal visible={isEventTypeModalVisible} transparent={true} animationType="fade">
          <TouchableOpacity
            onPress={() => {
              setIsEventTypeModalVisible(false);
              applyEventTypeChanges();
            }}
            style={{
              flex: 1,
              justifyContent: 'flex-end',
              backgroundColor: colors.overlayBackground,
            }}>
            <TouchableOpacity
              activeOpacity={1}
              onPress={e => {
                e.isPropagationStopped;
              }}
              style={{
                width: '100%',
                backgroundColor: colors.white,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                padding: hp('2%'),
                height: hp('30%'),
              }}>
              <Text style={{fontSize: hp('2.5%'), fontWeight: 'bold', marginBottom: hp('2%')}}>
                {t('events.eventtype')}
              </Text>
              <View
                style={{
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'flex-start',
                }}>
                {eventTypes.map(eventType => (
                  <TouchableOpacity
                    key={eventType.id}
                    style={{
                      paddingVertical: hp('1%'),
                      paddingHorizontal: hp('1.5%'),
                      borderRadius: 20,
                      backgroundColor:
                        tempSelectedEventType.id === eventType.id ? colors.eventInfluencer : colors.white,
                      borderWidth: 1,
                      borderColor: tempSelectedEventType.id === eventType.id ? colors.eventInfluencer : colors.gray400,
                      margin: hp('0.5%'),
                      marginBottom: hp('1%'),
                    }}
                    onPress={() => setTempSelectedEventType(eventType)}>
                    <Text
                      style={{
                        color: tempSelectedEventType.id === eventType.id ? colors.white : colors.black,
                        fontSize: hp('1.8%'),
                        fontWeight: '500',
                      }}>
                      {eventType.title === t('events.type') ? t('events.all') : eventType.title}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>
              <TouchableOpacity
                onPress={applyEventTypeChanges}
                style={{
                  marginTop: hp('1.5%'),
                  backgroundColor: colors.secondary,
                  paddingVertical: hp('1.25%'),
                  paddingHorizontal: hp('5%'),
                  borderRadius: 25,
                  width: '100%',
                  alignItems: 'center',
                  marginBottom: hp('1.5%'),
                }}>
                <Text style={{color: colors.white, fontSize: hp('2%'), fontWeight: 'bold'}}>{t('events.apply')}</Text>
              </TouchableOpacity>
            </TouchableOpacity>
          </TouchableOpacity>
        </Modal>

        {/* Neighbourhood Restriction Modal */}
        <NeighbourhoodRestrictionModal
          visible={isNeighbourhoodRestrictionModalVisible}
          onClose={() => setIsNeighbourhoodRestrictionModalVisible(false)}
        />
      </View>
    </TouchableWithoutFeedback>
  );
};

export default HomeScreenTabs;
